webpackJsonp(["comics"],{

/***/ "./src/client/actions/getData.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.receiveData = undefined;

var _reduxActions = __webpack_require__("./node_modules/redux-actions/es/index.js");

var _actionTypes = __webpack_require__("./src/client/constants/actionTypes.js");

var receiveData = exports.receiveData = (0, _reduxActions.createAction)(_actionTypes.RECEIVE_DATA);

/***/ }),

/***/ "./src/client/components/archive/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _styles = __webpack_require__("./src/client/components/archive/styles.less");

var _styles2 = _interopRequireDefault(_styles);

var _reactRouterDom = __webpack_require__("./node_modules/react-router-dom/es/index.js");

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Archive = function (_React$Component) {
    _inherits(Archive, _React$Component);

    function Archive(props) {
        _classCallCheck(this, Archive);

        var _this = _possibleConstructorReturn(this, (Archive.__proto__ || Object.getPrototypeOf(Archive)).call(this, props));

        _this.state = {};
        return _this;
    }

    _createClass(Archive, [{
        key: 'render',
        value: function render() {
            var archive = this.props.data;

            return _react2.default.createElement(
                'div',
                { className: this.props.className },
                _react2.default.createElement('div', { className: _styles2.default.archiveHeader }),
                _react2.default.createElement(
                    'div',
                    { className: _styles2.default.archiveContent },
                    Object.keys(archive).map(function (seriesID, i) {
                        var series = archive[seriesID];

                        if (!series.archiveThumbnail) return false;

                        return _react2.default.createElement(
                            'div',
                            {
                                key: i,
                                className: _styles2.default.series },
                            _react2.default.createElement(
                                _reactRouterDom.Link,
                                { to: '/comics/' + seriesID },
                                _react2.default.createElement(
                                    'div',
                                    { className: _styles2.default.image },
                                    _react2.default.createElement('img', {
                                        alt: series.title,
                                        src: series.archiveThumbnail
                                    })
                                ),
                                _react2.default.createElement(
                                    'h3',
                                    null,
                                    series.title
                                )
                            ),
                            _react2.default.createElement(
                                'p',
                                null,
                                _react2.default.createElement(
                                    'a',
                                    {
                                        href: series.artistSite,
                                        target: '_blank' },
                                    'by ',
                                    series.artist
                                )
                            )
                        );
                    })
                )
            );
        }
    }]);

    return Archive;
}(_react2.default.Component);

exports.default = Archive;

/***/ }),

/***/ "./src/client/components/archive/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"archiveHeader":"archive__archiveHeader_2XJGf","archiveContent":"archive__archiveContent_1OT52","series":"archive__series_1b3cQ","image":"archive__image_q13qm"};

/***/ }),

/***/ "./src/client/components/comics/comic.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _styles = __webpack_require__("./src/client/components/comics/styles.less");

var _styles2 = _interopRequireDefault(_styles);

var _reactRouterDom = __webpack_require__("./node_modules/react-router-dom/es/index.js");

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _image = __webpack_require__("./src/client/components/image/index.js");

var _image2 = _interopRequireDefault(_image);

var _drawingCanvas = __webpack_require__("./src/client/components/drawing-canvas/index.js");

var _drawingCanvas2 = _interopRequireDefault(_drawingCanvas);

var _comicsSelector = __webpack_require__("./src/client/selectors/comicsSelector.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Comic = function (_React$PureComponent) {
    _inherits(Comic, _React$PureComponent);

    function Comic(props) {
        _classCallCheck(this, Comic);

        var _this = _possibleConstructorReturn(this, (Comic.__proto__ || Object.getPrototypeOf(Comic)).call(this, props));

        _this.state = {
            imageLoaded: false
        };
        return _this;
    }

    _createClass(Comic, [{
        key: 'render',
        value: function render() {
            var data = this.props.data;
            var allSeries = this.props.series;
            var series = data.series ? allSeries[data.series] : data;
            var currentComic = this.props.comic ? this.props.comic : series.comics[data.index - 1];
            if (currentComic === undefined) {
                currentComic = series.comics[0];
            }

            var title = series.title + ' by ' + series.artist;

            var imageLoaded = this.state.imageLoaded;
            var isDrawable = this.getIsDrawable();
            var maxWidth = this.getMaxWidth();
            var isSubmittable = data.submitImage;
            var image = _react2.default.createElement(_image2.default, {
                data: currentComic,
                maxWidth: isDrawable && imageLoaded ? '' : maxWidth // don't set max width on image if this is a canvas
                , onLoad: this.handleImageLoaded.bind(this),
                title: title
            });
            var canvas = _react2.default.createElement(_drawingCanvas2.default, {
                className: _styles2.default.drawingWrapper,
                clear: true,
                image: image,
                isSubmittable: isSubmittable,
                maxWidth: maxWidth
            });

            var comicContent = isDrawable && imageLoaded ? canvas : image;

            return _react2.default.createElement(
                'div',
                { className: this.props.className },
                data.headerImage && _react2.default.createElement('img', {
                    className: _styles2.default.headerImage,
                    src: data.headerImage
                }),
                comicContent,
                series && series.comics && series.comics.length > 0 && this.props.seriesLink && _react2.default.createElement(
                    'div',
                    { className: _styles2.default.viewAll },
                    _react2.default.createElement(
                        'h3',
                        null,
                        this.props.series[data.series].title
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'a',
                            {
                                className: _styles2.default.artistSite,
                                href: this.props.series[data.series].artistSite,
                                target: '_blank' },
                            'by ',
                            this.props.series[data.series].artist
                        )
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: _styles2.default.viewAll },
                        _react2.default.createElement(
                            _reactRouterDom.Link,
                            {
                                className: _styles2.default.viewAllLink,
                                to: '/comics/' + data.series
                            },
                            'View Series'
                        )
                    )
                )
            );
        }
    }, {
        key: 'handleImageLoaded',
        value: function handleImageLoaded() {
            this.setState({ imageLoaded: true });
        }
    }, {
        key: 'getIsDrawable',
        value: function getIsDrawable() {
            var data = this.props.data;
            var allSeries = this.props.series;
            var series = data.series ? allSeries[data.series] : data;

            return (0, _lodash.get)(series, 'isDrawable', false);
        }
    }, {
        key: 'getMaxWidth',
        value: function getMaxWidth() {
            var data = this.props.data;

            return (0, _lodash.get)(data, 'maxWidth', null);
        }
    }]);

    return Comic;
}(_react2.default.PureComponent);

function mapStateToProps(state) {
    return {
        series: (0, _comicsSelector.comicsSelector)(state)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Comic);

/***/ }),

/***/ "./src/client/components/comics/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _styles = __webpack_require__("./src/client/components/comics/styles.less");

var _styles2 = _interopRequireDefault(_styles);

var _split = __webpack_require__("./src/client/components/split/index.js");

var _split2 = _interopRequireDefault(_split);

var _content = __webpack_require__("./src/client/components/content/index.js");

var _content2 = _interopRequireDefault(_content);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Comics = function (_React$Component) {
    _inherits(Comics, _React$Component);

    function Comics(props) {
        _classCallCheck(this, Comics);

        return _possibleConstructorReturn(this, (Comics.__proto__ || Object.getPrototypeOf(Comics)).call(this, props));
    }

    _createClass(Comics, [{
        key: 'componentWillMount',
        value: function componentWillMount() {}
    }, {
        key: 'render',
        value: function render() {
            var data = this.props.data;

            return _react2.default.createElement(
                'div',
                { className: this.props.className },
                data.map(function (section, i) {
                    if (section.type === 'split') {
                        return _react2.default.createElement(
                            'div',
                            {
                                key: i,
                                className: _styles2.default.splitWrapper
                            },
                            _react2.default.createElement(_split2.default, {
                                className: _styles2.default.split,
                                data: section
                            })
                        );
                    } else if (section.type === 'full') {
                        return _react2.default.createElement(
                            'div',
                            {
                                key: i,
                                className: _styles2.default.full
                            },
                            _react2.default.createElement(_content2.default, { data: section })
                        );
                    } else return null;
                })
            );
        }
    }]);

    return Comics;
}(_react2.default.Component);

exports.default = Comics;

/***/ }),

/***/ "./src/client/components/comics/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"full":"comics__full_3xuVY","splitWrapper":"comics__splitWrapper_1IF5y","split":"comics__split_12TWL","viewAll":"comics__viewAll_1nZZM","artistSite":"comics__artistSite_NcGlP","viewAllLink":"comics__viewAllLink_34Y5F","drawingWrapper":"comics__drawingWrapper_2U5Ox","headerImage":"comics__headerImage_NIyoL"};

/***/ }),

/***/ "./src/client/components/content/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _styles = __webpack_require__("./src/client/components/content/styles.less");

var _styles2 = _interopRequireDefault(_styles);

var _comic = __webpack_require__("./src/client/components/comics/comic.js");

var _comic2 = _interopRequireDefault(_comic);

var _promo = __webpack_require__("./src/client/components/promo/index.js");

var _promo2 = _interopRequireDefault(_promo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Content = function (_React$Component) {
    _inherits(Content, _React$Component);

    function Content(props) {
        _classCallCheck(this, Content);

        return _possibleConstructorReturn(this, (Content.__proto__ || Object.getPrototypeOf(Content)).call(this, props));
    }

    _createClass(Content, [{
        key: 'render',
        value: function render() {
            var data = this.props.data;

            if (data.series) {
                return this.renderComic(data);
            } else if (data.promo) {
                return this.renderPromo(data);
            }
        }
    }, {
        key: 'renderComic',
        value: function renderComic(data) {
            return _react2.default.createElement(_comic2.default, {
                className: _styles2.default.comic,
                data: data,
                seriesLink: true
            });
        }
    }, {
        key: 'renderPromo',
        value: function renderPromo(data) {
            return _react2.default.createElement(_promo2.default, {
                className: _styles2.default.comic,
                data: data
            });
        }
    }]);

    return Content;
}(_react2.default.Component);

exports.default = Content;

/***/ }),

/***/ "./src/client/components/content/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"comic":"content__comic_dBKhh"};

/***/ }),

/***/ "./src/client/components/drawing-canvas/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _config = __webpack_require__("./src/client/constants/config.js");

var Config = _interopRequireWildcard(_config);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _styles = __webpack_require__("./src/client/components/drawing-canvas/styles.less");

var _styles2 = _interopRequireDefault(_styles);

var _ismobilejs = __webpack_require__("./node_modules/ismobilejs/isMobile.js");

var _ismobilejs2 = _interopRequireDefault(_ismobilejs);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var _uploadForm = __webpack_require__("./src/client/components/upload-form/index.js");

var _uploadForm2 = _interopRequireDefault(_uploadForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Comic = function (_React$Component) {
    _inherits(Comic, _React$Component);

    function Comic(props) {
        _classCallCheck(this, Comic);

        var _this = _possibleConstructorReturn(this, (Comic.__proto__ || Object.getPrototypeOf(Comic)).call(this, props));

        _this.handleResize = (0, _lodash.debounce)(function () {
            _this.resetCanvas();
        }, 100);

        _this.handleOnMouseDown = function (e) {
            var rect = _this.state.canvas.getBoundingClientRect();
            _this.state.context.beginPath();
            if (_ismobilejs2.default.any) {
                _this.setState({
                    lastX: e.changedTouches[0].clientX - rect.left,
                    lastY: e.changedTouches[0].clientY - rect.top
                });
            } else {
                _this.setState({
                    lastX: e.clientX - rect.left,
                    lastY: e.clientY - rect.top
                });
            }

            _this.setState({
                drawing: true
            });
        };

        _this.handleOnMouseMove = function (e) {
            if (_this.state.drawing) {
                var rect = _this.state.canvas.getBoundingClientRect();
                var lastX = _this.state.lastX;
                var lastY = _this.state.lastY;
                var currentX = void 0;
                var currentY = void 0;

                if (_ismobilejs2.default.any) {
                    currentX = e.changedTouches[0].clientX - rect.left;
                    currentY = e.changedTouches[0].clientY - rect.top;

                    // Prevent the whole page from dragging if on mobile
                    e.preventDefault();
                } else {
                    currentX = e.clientX - rect.left;
                    currentY = e.clientY - rect.top;
                }

                _this.draw(lastX, lastY, currentX, currentY);
                _this.setState({
                    lastX: currentX,
                    lastY: currentY
                });
            }
        };

        _this.handleOnMouseUp = function () {
            _this.setState({
                drawing: false
            });
        };

        _this.draw = function (lX, lY, cX, cY) {
            _this.state.context.strokeStyle = _this.props.brushColor;
            _this.state.context.lineWidth = _this.props.lineWidth;

            if (_this.state.pencil) {
                _this.state.context.moveTo(lX, lY);
                _this.state.context.lineTo(cX, cY);
                _this.state.context.stroke();
            } else if (_this.state.eraser) {
                _this.state.context.arc(lX, lY, _this.props.eraserWidth, 0, Math.PI * 2, !0);
                _this.state.context.fill();
                _this.state.context.closePath();
            }
        };

        _this.state = {
            canvas: null,
            context: null,
            drawing: false,
            lastX: 0,
            lastY: 0,
            history: [],
            pencil: true,
            eraser: false,
            uploading: false,
            uploadForm: false,
            imageDataUrl: null
        };
        return _this;
    }

    _createClass(Comic, [{
        key: 'getDefaultStyle',
        value: function getDefaultStyle() {
            return {
                backgroundColor: 'transparent',
                maxWidth: '100%'
            };
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            window.addEventListener('resize', this.handleResize, false);
            var canvas = _reactDom2.default.findDOMNode(this).getElementsByTagName('canvas')[0];
            var image = canvas.offsetParent.getElementsByTagName('img')[0];

            canvas.width = image.offsetWidth;
            canvas.height = image.offsetHeight;

            var context = canvas.getContext('2d');

            var background = new Image();
            background.src = '/comics/proxy?url=' + image.getAttribute('src');
            // Make sure the image is loaded first otherwise nothing will draw.
            background.onload = function () {
                context.drawImage(background, 0, 0, background.width, background.height, 0, 0, canvas.width, canvas.height);
            };

            this.setState({
                canvas: canvas,
                context: context
            });
        }
    }, {
        key: 'resetCanvas',
        value: function resetCanvas() {
            var canvas = this.state.context.canvas;
            var image = canvas.offsetParent.getElementsByTagName('img')[0];
            canvas.width = image.offsetWidth;
            canvas.height = image.offsetHeight;
            var width = canvas.width;
            var height = canvas.height;
            this.state.context.clearRect(0, 0, width, height);
        }
    }, {
        key: 'canvasStyle',
        value: function canvasStyle() {
            var defaults = this.getDefaultStyle();
            var custom = this.props.canvasStyle;
            return Object.assign({}, defaults, custom);
        }
    }, {
        key: 'render',
        value: function render() {
            var _cx;

            var canvasClasses = (0, _classnames2.default)(_styles2.default.canvas, (_cx = {}, _defineProperty(_cx, _styles2.default.drawing, this.state.pencil), _defineProperty(_cx, _styles2.default.erasing, this.state.eraser), _cx));

            var pencilStyles = (0, _classnames2.default)(_styles2.default.pencil, _defineProperty({}, _styles2.default.enabled, !!this.state.pencil));

            var eraserStyles = (0, _classnames2.default)(_styles2.default.eraser, _defineProperty({}, _styles2.default.enabled, !!this.state.eraser));

            var showShare = true;

            return _react2.default.createElement(
                'div',
                { className: this.props.className },
                _react2.default.createElement(
                    'div',
                    {
                        className: _styles2.default.canvasWrapper,
                        style: { maxWidth: this.props.maxWidth + '%' }
                    },
                    _react2.default.createElement(
                        'div',
                        { className: _styles2.default.canvasDrawingArea },
                        this.props.image,
                        _react2.default.createElement('canvas', {
                            className: canvasClasses,
                            onMouseDown: this.handleOnMouseDown,
                            onMouseMove: this.handleOnMouseMove,
                            onMouseUp: this.handleOnMouseUp,
                            onTouchEnd: this.handleOnMouseUp,
                            onTouchMove: this.handleOnMouseMove,
                            onTouchStart: this.handleOnMouseDown,
                            style: this.canvasStyle() })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _styles2.default.canvasControls },
                        _react2.default.createElement(
                            'div',
                            {
                                className: pencilStyles,
                                onClick: this.handleDraw.bind(this)
                            },
                            _react2.default.createElement(
                                'svg',
                                {
                                    enableBackground: 'new 0 0 32.6 44.7',
                                    viewBox: '0 0 32.6 44.7',
                                    x: '0px',
                                    y: '0px' },
                                _react2.default.createElement(
                                    'g',
                                    null,
                                    _react2.default.createElement(
                                        'g',
                                        null,
                                        _react2.default.createElement('path', { d: 'M20.1,7.7c-5.9,8-11.6,16-17.2,24.2c-0.7,1.1,1,2.1,1.7,1c5.6-8.2,11.3-16.3,17.2-24.2C22.6,7.7,20.9,6.7,20.1,7.7L20.1,7.7z' })
                                    )
                                ),
                                _react2.default.createElement(
                                    'g',
                                    null,
                                    _react2.default.createElement(
                                        'g',
                                        null,
                                        _react2.default.createElement('path', { d: 'M26.6,11.7c-3.3,5-6.5,10.1-9.8,15.1c-1.4,2.2-2.6,4.8-4.3,6.7c-1.5,1.7-2.1,2.7-4.6,1.7C6.6,34.7,5,33,4,32.2c-1-0.8-2.4,0.6-1.4,1.4c2.4,1.8,4.7,4.2,7.5,5.4c0.3,0.1,0.7,0,1-0.3c3.4-2.9,5.6-8.1,8-11.8c3.1-4.8,6.1-9.5,9.2-14.3C29,11.6,27.3,10.6,26.6,11.7L26.6,11.7z' })
                                    )
                                ),
                                _react2.default.createElement(
                                    'g',
                                    null,
                                    _react2.default.createElement(
                                        'g',
                                        null,
                                        _react2.default.createElement('path', { d: 'M2,32.8C1.5,36.4,0.9,39.9,0,43.4c-0.2,0.8,0.7,1.6,1.5,1.1c3.1-1.9,6.2-3.6,9.4-5.3c1.1-0.6,0.1-2.3-1-1.7c-3.2,1.6-6.3,3.4-9.4,5.3C1,43.2,1.5,43.6,2,44c0.9-3.7,1.5-7.4,2-11.2C4.1,31.5,2.1,31.5,2,32.8L2,32.8z' })
                                    )
                                ),
                                _react2.default.createElement(
                                    'g',
                                    null,
                                    _react2.default.createElement(
                                        'g',
                                        null,
                                        _react2.default.createElement('path', { d: 'M1.2,42c0.3,0.1,0.5,0.3,0.6,0.6c0.6-0.3,1.2-0.5,1.8-0.8c-0.3-0.4-0.4-0.7-0.6-1.2c-0.5,0.4-1,0.8-1.5,1.1C2,42,2.4,42.2,2.8,42.5c0.4,0.3,1.1,0.1,1.4-0.4c0.3-0.5,0.1-1.1-0.4-1.4C3.4,40.5,3,40.3,2.7,40c-0.7-0.5-1.7,0.3-1.5,1.1c0.2,0.6,0.4,1.1,0.8,1.6c0.3,0.4,0.8,0.6,1.2,0.4C3.6,43,4,42.5,3.8,42c-0.3-0.8-0.8-1.4-1.6-1.8c-0.5-0.2-1.1-0.1-1.4,0.4C0.6,41,0.7,41.8,1.2,42L1.2,42z' })
                                    )
                                ),
                                _react2.default.createElement(
                                    'g',
                                    null,
                                    _react2.default.createElement(
                                        'g',
                                        null,
                                        _react2.default.createElement('path', { d: 'M20.3,8.1c0.9,1.4,2,2.7,3.2,3.9c0.9,0.8,2.4,2.4,3.6,2.3c0.5,0,0.8-0.3,1-0.7c0,0,0-0.1,0.1-0.1c0.2-0.4-0.1-0.9-0.5-1.1c0,0-0.1,0-0.1-0.1c-1-0.8-2,1-1,1.7c0,0,0.1,0,0.1,0.1c-0.2-0.4-0.3-0.8-0.5-1.1c0,0,0,0.1-0.1,0.1c0.3-0.2,0.6-0.5,1-0.7c0.2,0.1,0.3,0.1,0,0c-0.1-0.1-0.2-0.1-0.3-0.2c-0.3-0.2-0.5-0.4-0.8-0.5c-0.6-0.4-1.1-0.8-1.6-1.3c-1-0.9-1.8-1.9-2.5-3.1C21.3,6,19.6,7,20.3,8.1L20.3,8.1z' })
                                    )
                                ),
                                _react2.default.createElement(
                                    'g',
                                    null,
                                    _react2.default.createElement(
                                        'g',
                                        null,
                                        _react2.default.createElement('path', { d: 'M27.9,12.7c1.1-1.4,2.1-2.9,3-4.4c0.5-0.8,1.9-2.4,1.7-3.5c-0.2-1.1-1.6-1.6-2.4-2.1c-1.4-0.9-2.9-2.2-4.4-2.7c-0.3-0.1-0.7,0-1,0.3c-0.9,0.9-1.4,2.2-2.1,3.3C21.8,5,21,6.5,20.1,7.9c-0.7,1.1,1.1,2.1,1.7,1c0.7-1.2,1.4-2.4,2.1-3.6c0.7-1.1,1.3-2.7,2.2-3.6c-0.3,0.1-0.6,0.2-1,0.3c1,0.3,2,1.2,2.9,1.8c0.9,0.6,2.1,1.1,2.8,1.9c-0.1-0.3-0.2-0.6-0.3-1c-0.7,2.4-2.9,5-4.4,7C25.4,12.7,27.2,13.7,27.9,12.7L27.9,12.7z' })
                                    )
                                ),
                                _react2.default.createElement(
                                    'g',
                                    null,
                                    _react2.default.createElement(
                                        'g',
                                        null,
                                        _react2.default.createElement('path', { d: 'M22.7,6.4c1.7,0.9,3.2,1.8,4.7,3c1,0.8,2-1,1-1.7c-1.5-1.1-3.1-2.1-4.7-3C22.6,4.1,21.6,5.8,22.7,6.4L22.7,6.4z' })
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            {
                                className: eraserStyles,
                                onClick: this.handleErase.bind(this)
                            },
                            _react2.default.createElement(
                                'svg',
                                {
                                    enableBackground: 'new 0 0 42.5 25.1',
                                    viewBox: '0 0 42.5 25.1',
                                    x: '0px',
                                    y: '0px' },
                                _react2.default.createElement(
                                    'g',
                                    null,
                                    _react2.default.createElement(
                                        'g',
                                        null,
                                        _react2.default.createElement('path', { d: 'M23.2,0c-7.6,2.3-15,5-22.3,8.1C0.1,8.5,0.4,9.8,1.1,10c4.1,1,8.1,2.1,12,3.5c2.7,1,4,1.8,6.6,0.8c7.4-2.9,14.5-7,21.7-10.5c1-0.5,0.4-1.8-0.5-1.9c-6.3-0.4-12.6-0.8-19-1.2c-1.3-0.1-1.3,1.9,0,2c6.3,0.4,12.6,0.8,19,1.2c-0.2-0.6-0.3-1.2-0.5-1.9c-5.8,2.8-11.7,5.7-17.5,8.5c-2,1-4.1,2.2-6.5,2c-1.4-0.1-3.2-1.2-4.5-1.6C8.5,9.8,5.1,8.9,1.7,8c0.1,0.6,0.2,1.2,0.2,1.8C9,6.8,16.3,4.2,23.7,2C25,1.6,24.4-0.3,23.2,0L23.2,0z' })
                                    )
                                ),
                                _react2.default.createElement(
                                    'g',
                                    null,
                                    _react2.default.createElement(
                                        'g',
                                        null,
                                        _react2.default.createElement('path', { d: 'M0.2,8.3C0,11.7-0.1,15,0,18.3c0,1.5-0.1,2.8,1.5,3.3c1.2,0.4,2.8,0.2,4.1,0.5c1.4,0.3,2.8,0.7,4.2,1.2c2.2,0.7,4.7,1.7,7,1.3c0.3-0.1,0.6-0.4,0.7-0.7c0.9-2.7,0.6-6.3,0.9-9.2c0.1-1.3-1.9-1.3-2,0c-0.1,1.6,0.3,7.1-1.2,7.9c-0.7,0.4-3.5-0.8-4.3-1.1c-1.2-0.4-2.5-0.8-3.7-1.1c-1-0.2-1.9-0.4-2.9-0.6c-2.1-0.3-2.2,0-2.2-2.2c0-3.1,0-6.2,0.2-9.4C2.3,7,0.3,7,0.2,8.3L0.2,8.3z' })
                                    )
                                ),
                                _react2.default.createElement(
                                    'g',
                                    null,
                                    _react2.default.createElement(
                                        'g',
                                        null,
                                        _react2.default.createElement('path', { d: 'M17,25.1c4.7-1,9.3-2.3,13.7-4c3.1-1.2,8.3-2.7,10.5-5.3c1.9-2.1,1.1-6.1,1.2-8.8c0.1-2,0.6-4-1.5-4.9c-1.2-0.5-1.7,1.5-0.5,1.9c0.4,0.1,0.1,6.9-0.1,7.6c-1.3,4.1-5,5.4-8.6,6.9c-4.9,2.1-10,3.6-15.2,4.7C15.2,23.4,15.7,25.3,17,25.1L17,25.1z' })
                                    )
                                )
                            )
                        ),
                        this.state.working !== 'twitter' && showShare && _react2.default.createElement(
                            'div',
                            {
                                className: _styles2.default.twitter,
                                onClick: this.handleTwitter.bind(this)
                            },
                            _react2.default.createElement(
                                'svg',
                                {
                                    enableBackground: 'new 0 0 36.4 28.8',
                                    viewBox: '0 0 36.4 28.8',
                                    x: '0px',
                                    y: '0px' },
                                _react2.default.createElement(
                                    'g',
                                    null,
                                    _react2.default.createElement(
                                        'g',
                                        null,
                                        _react2.default.createElement('path', { d: 'M30.8,0.4c-0.9,1-2.1,2.3-3.5,1.7c-0.6-0.2-1.1-0.8-1.6-1.1c-1.6-0.7-3.4-0.8-5-0.1c-3.7,1.5-4.4,5.4-4.1,9c0.2-0.2,0.4-0.3,0.6-0.5c-5.3-1.2-10.1-3.7-14-7.4C3,1.7,2.5,1.8,2.4,2.2c-0.7,3.3-0.3,6.4,1.2,9.4c0.2-0.2,0.5-0.5,0.7-0.7C3,10.3,1.9,10,0.5,10C0.2,10,0,10.2,0,10.5c0,3.6,2.7,6.4,6.2,6.7c0-0.3-0.1-0.7-0.1-1c-1.3,0.2-2.5,0.5-3.7,1c-0.3,0.1-0.5,0.5-0.3,0.7C4,20.5,6.4,23,9.9,22.2c-0.1-0.3-0.3-0.6-0.4-0.9c-2.6,2-5.6,3-8.9,3c-0.4,0-0.6,0.5-0.4,0.9c5.1,5.4,13.3,4.3,18.7,0.1c3.1-2.4,5.8-5.7,7.7-9.2c1-1.8,1.2-5.1,2.7-6.4c1.8-1.6,4.7-2.5,6.8-3.7c0.4-0.2,0.2-1-0.3-0.9c-2.3,0.1-4.6,0.3-6.8,0.4c0.1,0.3,0.2,0.6,0.4,0.9c1.8-1.5,3-3.4,3.7-5.6c0.1-0.4-0.3-0.7-0.6-0.6c-0.7,0.2-1.3,0.5-1.9,0.8c-0.6,0.3-0.1,1.2,0.5,0.9c0.5-0.3,1-0.6,1.6-0.7c-0.2-0.2-0.4-0.4-0.6-0.6c-0.7,2.1-1.8,3.7-3.4,5.2c-0.3,0.3-0.1,0.9,0.4,0.9c2.3-0.1,4.6-0.3,6.8-0.4c-0.1-0.3-0.2-0.6-0.3-0.9c-1.9,1.1-3.9,2.1-5.8,3.2c-1,0.6-1.9,1-2.3,2.2c-0.7,1.8-0.9,3.7-1.9,5.4c-1,1.7-2.2,3.4-3.5,4.9C17,26.7,7.3,31.3,0.9,24.4c-0.1,0.3-0.2,0.6-0.4,0.9c3.5-0.1,6.6-1.1,9.4-3.2c0.4-0.3,0.2-1.1-0.4-0.9c-3.1,0.8-5-1.7-6.6-3.8c-0.1,0.2-0.2,0.5-0.3,0.7c1.2-0.5,2.4-0.8,3.7-1c0.6-0.1,0.4-0.9-0.1-1C4.3,16,2.7,15,1.7,13.4c-0.2-0.3-0.8-1.4-0.7-1.7c0.4-1.2,2.1-0.1,2.7,0.1c0.5,0.2,0.9-0.2,0.7-0.7C3.1,8.3,2.7,5.5,3.3,2.4C3.1,2.5,2.8,2.6,2.5,2.7c4.1,3.9,9,6.5,14.4,7.7c0.3,0.1,0.7-0.1,0.6-0.5c-0.2-2.7-0.1-5.7,2.4-7.4c2.5-1.8,5.5-1.1,7.4,1.1c0.1,0.1,0.3,0.2,0.5,0.1c1.5-0.6,2.7-1.4,3.7-2.6C32,0.6,31.3-0.1,30.8,0.4L30.8,0.4z' })
                                    )
                                )
                            )
                        ),
                        this.state.working === 'twitter' && this.uploadingImage(),
                        this.state.working !== 'facebook' && showShare && _react2.default.createElement(
                            'div',
                            {
                                className: _styles2.default.facebook,
                                onClick: this.handleFacebook.bind(this) },
                            _react2.default.createElement(
                                'svg',
                                {
                                    enableBackground: 'new 0 0 23.9 23.5',
                                    viewBox: '0 0 23.9 23.5',
                                    x: '0px',
                                    y: '0px' },
                                _react2.default.createElement(
                                    'g',
                                    null,
                                    _react2.default.createElement('path', {
                                        d: 'M9.5,0.6c-2.1-0.1-4.1,0-6.2,0.2C2.8,0.9,2.2,1,1.8,1.3 c-1,0.6-1.2,1.8-1.2,2.9C0.4,9.2,0.5,14.3,1,19.4c0.1,1.2,0.4,2.6,1.5,3.1c0.5,0.2,1,0.3,1.5,0.3c2.3,0.2,4.6,0.2,6.9-0.1 c-0.3-3-0.5-6-0.8-9c0-0.2,0-0.3-0.1-0.5c-0.5-1-2.2-0.2-3.3-0.6c-1.2-0.5-0.9-2.1,0.2-2.7c1.1-0.6,2.4-0.5,3.7-0.3 c-0.8-2.1,0-4.6,1.8-6.1c1.7-1.4,4.2-1.8,6.3-1c2.1,0.8,3.4,3,2.8,4.9c-0.7,0.2-1.5,0.5-2.2,0.7c-0.8-0.8-1-2.2-2.1-2.5 c-1-0.4-2.2,0.4-2.5,1.4c-0.3,0.9-0.1,2,0.2,2.9c0.7-0.6,2-0.2,2.3,0.5c0.4,0.8-0.1,1.7-0.9,2.2c-0.8,0.5-1.8,0.5-2.7,0.3 c0.2,3.3,0.6,6.7,1.3,10c2,0.2,4,0.1,5.8-0.5c0.6-0.2,1.2-0.4,1.6-0.7c0.5-0.4,0.7-1.1,0.8-1.7c0.4-2,0.4-4,0.3-6 c-0.1-3.4-0.2-6.7-0.3-10.1c0-0.7,0-1.4-0.4-2c-0.9-1.4-3-1.4-4.8-1.3c-2.7,0.2-5.4,0.4-8.1,0.5',
                                        fill: 'none',
                                        stroke: '#000000',
                                        strokeMiterlimit: '10'
                                    })
                                )
                            )
                        ),
                        this.state.working === 'facebook' && this.uploadingImage(),
                        this.state.working !== 'download' && _react2.default.createElement(
                            'div',
                            {
                                className: _styles2.default.download,
                                onClick: this.handleDownload.bind(this)
                            },
                            _react2.default.createElement(
                                'svg',
                                {
                                    enableBackground: 'new 0 0 27.7 35',
                                    viewBox: '0 0 27.7 35',
                                    x: '0px',
                                    y: '0px' },
                                _react2.default.createElement(
                                    'g',
                                    null,
                                    _react2.default.createElement(
                                        'g',
                                        null,
                                        _react2.default.createElement('path', { d: 'M0.7,1.4C0.6,4.9,0.5,8.3,0.4,11.8c0,1.7-0.1,3.5-0.1,5.2c0,1.2-0.5,4.1-0.1,5.2c0.9,2.6,4.3,2.2,6.7,2.2c1.3,0,1.3-2,0-2c-3.5,0-4.2-0.2-4.6-3.6C2,17,2.3,15.2,2.4,13.5c0.1-4,0.2-8.1,0.3-12.1C2.7,0.1,0.7,0.1,0.7,1.4L0.7,1.4z' })
                                    )
                                ),
                                _react2.default.createElement(
                                    'g',
                                    null,
                                    _react2.default.createElement(
                                        'g',
                                        null,
                                        _react2.default.createElement('path', { d: 'M13.6,17c0.2,5,0.1,9.9-0.4,14.9c-0.1,1.3,1.9,1.3,2,0c0.5-4.9,0.7-9.9,0.4-14.9C15.5,15.7,13.5,15.7,13.6,17L13.6,17z' })
                                    )
                                ),
                                _react2.default.createElement(
                                    'g',
                                    null,
                                    _react2.default.createElement(
                                        'g',
                                        null,
                                        _react2.default.createElement('path', { d: 'M10.1,30.4c1.3,1.4,2.6,2.9,3.9,4.3c0.5,0.5,1.2,0.3,1.6-0.2c1.1-1.5,2.4-2.9,3.9-4.1c1-0.8-0.4-2.2-1.4-1.4c-1.6,1.4-2.9,2.9-4.2,4.5c0.5-0.1,1-0.1,1.6-0.2c-1.3-1.4-2.6-2.9-3.9-4.3C10.6,28,9.2,29.4,10.1,30.4L10.1,30.4z' })
                                    )
                                ),
                                _react2.default.createElement(
                                    'g',
                                    null,
                                    _react2.default.createElement(
                                        'g',
                                        null,
                                        _react2.default.createElement('path', { d: 'M2.5,2c8.1,0,16.1,0.4,24.2,1.4c-0.3-0.3-0.7-0.7-1-1c0,6.6,0,13.2,0,19.8c0.3-0.3,0.7-0.7,1-1c-1.8,0.1-3.5,0.3-5.3,0.4c-1.3,0.1-1.3,2.1,0,2c1.8-0.1,3.5-0.3,5.3-0.4c0.5,0,1-0.4,1-1c0-6.6,0-13.2,0-19.8c0-0.6-0.5-0.9-1-1C18.7,0.4,10.6,0,2.5,0C1.2,0,1.2,2,2.5,2L2.5,2z' })
                                    )
                                )
                            )
                        ),
                        this.state.working === 'download' && this.uploadingImage()
                    )
                ),
                this.props.isSubmittable && _react2.default.createElement('img', {
                    className: _styles2.default.submitButton,
                    onClick: this.handleImageSubmit.bind(this),
                    src: 'https://i.cdn.turner.com/adultswim/big/img/2017/02/09/submit-button.png'
                }),
                this.state.uploadForm && _react2.default.createElement(_uploadForm2.default, {
                    className: _styles2.default.uploadForm,
                    handleUploadFormClose: this.uploadFormClose.bind(this),
                    imageUrl: this.state.imageDataUrl
                })
            );
        }
    }, {
        key: 'uploadingImage',
        value: function uploadingImage() {
            return _react2.default.createElement(
                'div',
                { className: _styles2.default.uploading },
                _react2.default.createElement('img', { src: 'https://i.cdn.turner.com/adultswim/big/img/2017/02/09/working.gif' })
            );
        }
    }, {
        key: 'handleDraw',
        value: function handleDraw() {
            this.state.context.globalCompositeOperation = 'source-over';

            this.setState({
                eraser: false,
                pencil: true
            });
        }
    }, {
        key: 'handleErase',
        value: function handleErase() {
            this.state.context.globalCompositeOperation = 'destination-out';

            this.setState({
                eraser: true,
                pencil: false
            });
        }
    }, {
        key: 'handleDownload',
        value: function handleDownload() {
            var _this2 = this;

            this.setState({
                working: 'download'
            });

            // setting a reference to window so we can use it in an async call (safari blocks window.open in async functions)
            var windowReference = null;
            if (this.isSafari()) windowReference = window.open();

            this.getDataUrl().then(function (dataURL) {
                _this2.newImage(dataURL).then(function (res) {
                    setTimeout(function () {
                        _this2.setState({ working: false });
                        var uri = res.data.url;
                        if (!windowReference) window.open(uri, '_blank');else windowReference.location = uri;
                    }, 1000);
                });
            });
        }
    }, {
        key: 'handleFacebook',
        value: function handleFacebook() {
            var _this3 = this;

            this.setState({
                working: 'facebook'
            });

            // setting a reference to window so we can use it in an async call (safari blocks window.open in async functions)
            var windowReference = null;
            if (this.isSafari()) windowReference = window.open();

            this.getDataUrl().then(function (dataURL) {
                _this3.newImage(dataURL).then(function (res) {
                    setTimeout(function () {
                        _this3.setState({ working: false });
                        var uri = Config.FACEBOOK_IMAGE_SHARE + encodeURI(res.data.url);
                        if (!windowReference) window.open(uri, '_blank');else windowReference.location = uri;
                    }, 500);
                });
            });
        }
    }, {
        key: 'handleTwitter',
        value: function handleTwitter() {
            var _this4 = this;

            this.setState({
                working: 'twitter'
            });

            // setting a reference to window so we can use it in an async call (safari blocks window.open in async functions)
            var windowReference = null;
            if (this.isSafari()) windowReference = window.open();

            this.getDataUrl().then(function (dataURL) {
                _this4.newImage(dataURL).then(function (res) {
                    setTimeout(function () {
                        _this4.setState({ working: false });
                        var uri = Config.TWITTER_IMAGE_SHARE + encodeURI(res.data.url);
                        if (!windowReference) window.open(uri, '_blank');else windowReference.location = uri;
                    }, 500);
                });
            });
        }
    }, {
        key: 'getDataUrl',
        value: function getDataUrl() {
            var _this5 = this;

            var canvas = this.state.canvas;
            var image = canvas.offsetParent.getElementsByTagName('img')[0];

            var background = new Image();
            background.src = '/comics/proxy?url=' + image.getAttribute('src');

            return new Promise(function (resolve) {
                background.onload = resolve;
            }).then(function () {
                // Create an ImageData object from it
                // let canvas = this.state.canvas;
                var context = _this5.state.context;
                var imagedata = context.getImageData(0, 0, _this5.state.canvas.width, _this5.state.canvas.height);
                var isPencil = _this5.state.pencil;
                var isEraser = _this5.state.eraser;

                // removes the white from the eraser when the background image is loaded in (canvas bug)
                context.globalCompositeOperation = 'destination-over';
                context.putImageData(imagedata, 0, 0);
                context.drawImage(background, 0, 0, background.width, background.height, 0, 0, canvas.width, canvas.height);
                var dataURL = canvas.toDataURL('image/png');
                context.globalCompositeOperation = !isPencil && isEraser ? 'destination-out' : 'source-over';

                return dataURL;
            });
        }
    }, {
        key: 'isSafari',
        value: function isSafari() {
            return navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1;
        }
    }, {
        key: 'handleImageSubmit',
        value: function handleImageSubmit() {
            var _this6 = this;

            this.getDataUrl().then(function (dataURL) {
                _this6.setState({
                    uploadForm: true,
                    imageDataUrl: dataURL
                });
            });
        }
    }, {
        key: 'uploadFormClose',
        value: function uploadFormClose() {
            this.setState({
                uploadForm: false
            });
        }
    }, {
        key: 'newImage',
        value: function newImage(dataURL) {
            var metadata = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var save = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            return fetch(Config.IMAGE_UPLOAD_URL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    'dataURL': dataURL,
                    'save': save,
                    'metadata': metadata
                })
            }).then(function (res) {
                return res.json();
            }).catch(function (err) {
                console.log(err);
            });
        }
    }]);

    return Comic;
}(_react2.default.Component);

Comic.defaultProps = {
    brushColor: '#ff0000',
    lineWidth: 2,
    eraserWidth: 10,
    canvasStyle: {
        backgroundColor: 'transparent',
        maxWidth: '100%'
    },
    clear: false
};
exports.default = Comic;

/***/ }),

/***/ "./src/client/components/drawing-canvas/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"canvas":"drawing-canvas__canvas_11jQ2","drawing":"drawing-canvas__drawing_cSaDA","erasing":"drawing-canvas__erasing_1dLoc","canvasWrapper":"drawing-canvas__canvasWrapper_2vfj2","canvasDrawingArea":"drawing-canvas__canvasDrawingArea_2xXde","canvasControls":"drawing-canvas__canvasControls_2wPuZ","pencil":"drawing-canvas__pencil_3lKQy","eraser":"drawing-canvas__eraser_2ssxa","download":"drawing-canvas__download_1XhU6","twitter":"drawing-canvas__twitter_gWD8l","facebook":"drawing-canvas__facebook_1qpxV","enabled":"drawing-canvas__enabled_33O_C","uploading":"drawing-canvas__uploading_1-9sN","submitButton":"drawing-canvas__submitButton_35bya","uploadForm":"drawing-canvas__uploadForm_2gvl2"};

/***/ }),

/***/ "./src/client/components/hero/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _styles = __webpack_require__("./src/client/components/hero/styles.less");

var _styles2 = _interopRequireDefault(_styles);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Hero(props) {
    var classes = (0, _classnames2.default)(_styles2.default.root, props.className);
    props = props.data;

    return _react2.default.createElement(
        'div',
        { className: classes },
        props.content.map(function (item, i) {
            var image = _react2.default.createElement('img', {
                alt: item.title,
                src: item.image
            });
            var linkImage = _react2.default.createElement(
                'a',
                {
                    key: i,
                    href: item.link },
                image
            );

            return item.link ? linkImage : image;
        })
    );
}

exports.default = Hero;

/***/ }),

/***/ "./src/client/components/hero/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"hero__root_19h4D"};

/***/ }),

/***/ "./src/client/components/image/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _styles = __webpack_require__("./src/client/components/image/styles.less");

var _styles2 = _interopRequireDefault(_styles);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Image = function (_React$Component) {
    _inherits(Image, _React$Component);

    function Image(props) {
        _classCallCheck(this, Image);

        var _this = _possibleConstructorReturn(this, (Image.__proto__ || Object.getPrototypeOf(Image)).call(this, props));

        _this.state = {};
        return _this;
    }

    _createClass(Image, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var img = _reactDom2.default.findDOMNode(this);
            if (img.complete) {
                this.props.onLoad();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var mobileImageUrl = void 0,
                desktopImageUrl = void 0;
            var _props = this.props,
                data = _props.data,
                title = _props.title,
                maxWidth = _props.maxWidth,
                onLoad = _props.onLoad;


            if ((0, _lodash.isString)(data)) {
                desktopImageUrl = data;
            } else {
                mobileImageUrl = (0, _lodash.isObject)(data.mobile) ? data.mobile.url : data.mobile;
                desktopImageUrl = (0, _lodash.isObject)(data.desktop) ? data.desktop.url : data.desktop;
            }

            var style = {
                maxWidth: maxWidth ? maxWidth + '%' : '100%'
            };

            if (!mobileImageUrl) return _react2.default.createElement('img', {
                alt: title,
                className: _styles2.default.image,
                onLoad: onLoad,
                src: desktopImageUrl,
                style: style
            });else return _react2.default.createElement(
                'picture',
                null,
                _react2.default.createElement('source', {
                    media: '(max-width: 800px)',
                    srcSet: mobileImageUrl
                }),
                _react2.default.createElement('img', {
                    alt: title,
                    className: _styles2.default.image,
                    src: desktopImageUrl,
                    style: style
                })
            );
        }
    }]);

    return Image;
}(_react2.default.Component);

exports.default = Image;

/***/ }),

/***/ "./src/client/components/image/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"image":"image__image_2j8F9"};

/***/ }),

/***/ "./src/client/components/promo/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _image = __webpack_require__("./src/client/components/image/index.js");

var _image2 = _interopRequireDefault(_image);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Promo = function (_React$Component) {
    _inherits(Promo, _React$Component);

    function Promo(props) {
        _classCallCheck(this, Promo);

        return _possibleConstructorReturn(this, (Promo.__proto__ || Object.getPrototypeOf(Promo)).call(this, props));
    }

    _createClass(Promo, [{
        key: 'render',
        value: function render() {
            var promo = this.props.data.promo;


            var image = _react2.default.createElement(_image2.default, {
                data: promo.image,
                title: promo.title
            });

            var content = void 0;

            if (promo.link) {
                content = _react2.default.createElement(
                    'a',
                    { href: promo.link },
                    image
                );
            } else {
                content = image;
            }

            return _react2.default.createElement(
                'div',
                { className: this.props.className },
                content
            );
        }
    }]);

    return Promo;
}(_react2.default.Component);

exports.default = Promo;

/***/ }),

/***/ "./src/client/components/series/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _styles = __webpack_require__("./src/client/components/series/styles.less");

var _styles2 = _interopRequireDefault(_styles);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__("./node_modules/react-router-dom/es/index.js");

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _comic = __webpack_require__("./src/client/components/comics/comic.js");

var _comic2 = _interopRequireDefault(_comic);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Content = function (_React$Component) {
    _inherits(Content, _React$Component);

    function Content(props) {
        _classCallCheck(this, Content);

        var _this = _possibleConstructorReturn(this, (Content.__proto__ || Object.getPrototypeOf(Content)).call(this, props));

        _this.handleOverlayClose = function () {
            _this.setState({
                shown: false
            });
        };

        _this.state = {
            shown: true,
            reverseOrder: false
        };
        return _this;
    }

    _createClass(Content, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            document.body.classList.add('noscroll');
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            document.body.classList.remove('noscroll');
        }
    }, {
        key: 'render',
        value: function render() {
            var _cx;

            var data = this.props.data;
            var artist = this.props.artist;

            var className = (0, _classnames2.default)(_styles2.default.root, this.props.className, (_cx = {}, _defineProperty(_cx, _styles2.default.shown, this.state.shown), _defineProperty(_cx, _styles2.default.hide, !this.state.shown), _cx));

            if (data.reverse) data.comicsOrder = data.comics.slice(0).reverse();else {
                data.comicsOrder = data.comics;
            }

            return _react2.default.createElement(
                'div',
                {
                    className: className,
                    onAnimationEnd: this.handleAnimationEnd },
                _react2.default.createElement(
                    _reactRouterDom.Link,
                    {
                        className: _styles2.default.closeOverlay,
                        onClick: this.handleOverlayClose,
                        to: '/comics/' },
                    _react2.default.createElement('img', {
                        alt: 'Back to Comics',
                        src: 'https://i.cdn.turner.com/adultswim/big/img/2017/03/16/comics-back-button.png'
                    })
                ),
                _react2.default.createElement(
                    'h2',
                    null,
                    data.title
                ),
                _react2.default.createElement(
                    'h3',
                    null,
                    _react2.default.createElement(
                        'a',
                        {
                            href: artist.artistSite,
                            target: '_blank' },
                        artist.name
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: _styles2.default.seriesComics },
                    data.comicsOrder.map(function (comic, i) {
                        return _react2.default.createElement(_comic2.default, {
                            key: i,
                            comic: comic,
                            data: data,
                            title: data.title + ' by ' + artist.name
                        });
                    })
                )
            );
        }
    }]);

    return Content;
}(_react2.default.Component);

exports.default = Content;

/***/ }),

/***/ "./src/client/components/series/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"canvas":"series__canvas_23VJW","drawing":"series__drawing_Yzx2v","erasing":"series__erasing_1U7OS","root":"series__root_5wfcy","shown":"series__shown_-A0a1","showOverlay":"series__showOverlay_vfmCV","hide":"series__hide_3t8NP","hideOverlay":"series__hideOverlay_2-7o1","seriesComics":"series__seriesComics_Y92Lk","comicIssue":"series__comicIssue_1KBFY","closeOverlay":"series__closeOverlay_GVdYr","canvasWrapper":"series__canvasWrapper_2Fq03"};

/***/ }),

/***/ "./src/client/components/split/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _styles = __webpack_require__("./src/client/components/split/styles.less");

var _styles2 = _interopRequireDefault(_styles);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _content = __webpack_require__("./src/client/components/content/index.js");

var _content2 = _interopRequireDefault(_content);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Split = function (_React$Component) {
    _inherits(Split, _React$Component);

    function Split(props) {
        _classCallCheck(this, Split);

        var _this = _possibleConstructorReturn(this, (Split.__proto__ || Object.getPrototypeOf(Split)).call(this, props));

        _this.state = {};
        return _this;
    }

    _createClass(Split, [{
        key: 'render',
        value: function render() {
            var data = this.props.data;
            var left = data.left,
                right = data.right;


            var leftClassName = (0, _classnames2.default)(_styles2.default.column, _styles2.default[left.size]);
            var rightClassName = (0, _classnames2.default)(_styles2.default.column, _styles2.default[right.size]);

            return _react2.default.createElement(
                'div',
                { className: this.props.className },
                _react2.default.createElement(
                    'div',
                    { className: leftClassName },
                    left.content.map(function (content, i) {
                        return _react2.default.createElement(_content2.default, {
                            key: i,
                            data: content
                        });
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: rightClassName },
                    right.content.map(function (content, i) {
                        return _react2.default.createElement(_content2.default, {
                            key: i,
                            data: content
                        });
                    })
                )
            );
        }
    }]);

    return Split;
}(_react2.default.Component);

exports.default = Split;

/***/ }),

/***/ "./src/client/components/split/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"column":"split__column_1dKAU","one-thirds":"split__one-thirds_K2o7Y","oneThirds":"split__one-thirds_K2o7Y","two-thirds":"split__two-thirds_PQF9C","twoThirds":"split__two-thirds_PQF9C","three-fourths":"split__three-fourths_2Mbp2","threeFourths":"split__three-fourths_2Mbp2","one-fourths":"split__one-fourths_3P5wh","oneFourths":"split__one-fourths_3P5wh"};

/***/ }),

/***/ "./src/client/components/upload-form/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _styles = __webpack_require__("./src/client/components/upload-form/styles.less");

var _styles2 = _interopRequireDefault(_styles);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _config = __webpack_require__("./src/client/constants/config.js");

var Config = _interopRequireWildcard(_config);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UploadForm = function (_React$Component) {
    _inherits(UploadForm, _React$Component);

    function UploadForm(props) {
        _classCallCheck(this, UploadForm);

        var _this = _possibleConstructorReturn(this, (UploadForm.__proto__ || Object.getPrototypeOf(UploadForm)).call(this, props));

        _this.handleChange = function (event) {
            var target = event.target;
            var value = target.type === 'checkbox' ? target.checked : target.value;
            var name = target.name;

            _this.setState(_defineProperty({}, name + 'Value', value));
        };

        _this.handleOverlayClose = function () {
            _this.setState({
                shown: false
            });
        };

        _this.handleAnimationEnd = function () {
            if (!_this.state.shown) _this.props.handleUploadFormClose();
        };

        _this.handleFormSubmit = function (event) {
            event.preventDefault();

            _this.setState({
                nameError: !_this.state.nameValue,
                emailError: !_this.state.emailValue,
                agreeError: !_this.state.agreeValue
            });

            if (!_this.state.nameValue || !_this.state.emailValue || !_this.state.agreeValue) return false;

            _this.setState({
                uploading: true
            });

            var finalData = {
                name: _this.state.nameValue,
                email: _this.state.emailValue
            };

            fetch(Config.IMAGE_UPLOAD_URL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    'dataURL': _this.props.imageUrl,
                    'save': true,
                    'metadata': finalData
                })
            }).then(function () {
                _this.setState({ uploading: false, thanks: true });
            }).catch(function (err) {
                console.log(err);
            });

            // this.props.uploadImage(this.props.imageUrl, finalData, true)
            //     .then(() => {
            //
            //     });
        };

        _this.state = {
            shown: true,
            nameError: false,
            emailError: false,
            agreeError: false,
            uploading: false,
            thanks: false,
            nameValue: '',
            emailValue: '',
            agreeValue: ''
        };
        return _this;
    }

    _createClass(UploadForm, [{
        key: 'render',
        value: function render() {
            var _cx;

            var imageUrl = this.props.imageUrl;

            var className = (0, _classnames2.default)(_styles2.default.root, this.props.className, (_cx = {}, _defineProperty(_cx, _styles2.default.shown, this.state.shown), _defineProperty(_cx, _styles2.default.hide, !this.state.shown), _cx));

            var nameInputWrapperStyles = (0, _classnames2.default)(_styles2.default.inputWrapper, _defineProperty({}, _styles2.default.error, this.state.nameError));

            var emailInputWrapperStyles = (0, _classnames2.default)(_styles2.default.inputWrapper, _defineProperty({}, _styles2.default.error, this.state.emailError));

            var agreeInputWrapperStyles = (0, _classnames2.default)(_styles2.default.checkboxWrapper, _defineProperty({}, _styles2.default.error, this.state.agreeError));

            return _react2.default.createElement(
                'div',
                {
                    className: className,
                    onAnimationEnd: this.handleAnimationEnd },
                _react2.default.createElement(
                    'div',
                    {
                        className: _styles2.default.close,
                        onClick: this.handleOverlayClose },
                    _react2.default.createElement('img', { src: 'https://i.cdn.turner.com/adultswim/big/img/2017/02/09/upload-close.png' })
                ),
                this.state.thanks && _react2.default.createElement(
                    'div',
                    { className: _styles2.default.thanks },
                    _react2.default.createElement('img', { src: 'https://i.cdn.turner.com/adultswim/big/img/2017/02/13/thanks.png' })
                ),
                !this.state.thanks && _react2.default.createElement(
                    'span',
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: _styles2.default.previewArea },
                        _react2.default.createElement(
                            'div',
                            { className: _styles2.default.previewImage },
                            _react2.default.createElement('img', { src: imageUrl })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: _styles2.default.uploadCopy },
                            _react2.default.createElement('img', { src: 'https://i.cdn.turner.com/adultswim/big/img/2017/02/09/submit-description.png' })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _styles2.default.formWrapper },
                        _react2.default.createElement(
                            'form',
                            {
                                onSubmit: this.handleFormSubmit },
                            _react2.default.createElement(
                                'div',
                                { className: nameInputWrapperStyles },
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'input-name' },
                                    'Name:'
                                ),
                                _react2.default.createElement('input', {
                                    name: 'name',
                                    onChange: this.handleChange,
                                    type: 'text',
                                    value: this.state.nameValue
                                })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: emailInputWrapperStyles },
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'input-email' },
                                    'Email:'
                                ),
                                _react2.default.createElement('input', {
                                    name: 'email',
                                    onChange: this.handleChange,
                                    type: 'text',
                                    value: this.state.emailValue
                                })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: agreeInputWrapperStyles },
                                _react2.default.createElement('input', {
                                    checked: this.state.agreeValue ? 'checked' : null,
                                    name: 'agree',
                                    onChange: this.handleChange,
                                    type: 'checkbox'
                                }),
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'input-checkbox' },
                                    'I agree to these',
                                    _react2.default.createElement(
                                        'a',
                                        {
                                            href: '/footer/legal/submit-your-drawing.html',
                                            target: '_blank' },
                                        'rules'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: _styles2.default.submitWrapper },
                                _react2.default.createElement('input', {
                                    name: 'submit',
                                    src: 'https://i.cdn.turner.com/adultswim/big/img/2017/02/09/submit-button-white.png',
                                    type: 'image',
                                    value: 'submit'
                                }),
                                this.state.uploading && _react2.default.createElement('img', {
                                    className: _styles2.default.loadingIcon,
                                    src: 'https://i.cdn.turner.com/adultswim/big/img/2017/02/13/workingWhite.gif'
                                })
                            )
                        )
                    )
                )
            );
        }
    }]);

    return UploadForm;
}(_react2.default.Component);

exports.default = UploadForm;

/***/ }),

/***/ "./src/client/components/upload-form/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"canvas":"upload-form__canvas_19tv3","drawing":"upload-form__drawing_2CPr4","erasing":"upload-form__erasing_3EMxM","root":"upload-form__root_32bGb","shown":"upload-form__shown_yf5UE","showOverlay":"upload-form__showOverlay_2RxEz","hide":"upload-form__hide_AiFuD","hideOverlay":"upload-form__hideOverlay_1rdhI","close":"upload-form__close_Xmed4","previewArea":"upload-form__previewArea_1Hd_q","previewImage":"upload-form__previewImage_1BQ4I","uploadCopy":"upload-form__uploadCopy_2Ak2f","formWrapper":"upload-form__formWrapper_gzymQ","inputWrapper":"upload-form__inputWrapper_30M00","error":"upload-form__error_1aA2R","checkboxWrapper":"upload-form__checkboxWrapper_1W8Mp","submitWrapper":"upload-form__submitWrapper_3Wb5k","loadingIcon":"upload-form__loadingIcon_2FA30","thanks":"upload-form__thanks_2rKLF"};

/***/ }),

/***/ "./src/client/constants/actionTypes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var RECEIVE_DATA = exports.RECEIVE_DATA = 'RECEIVE_DATA';

/***/ }),

/***/ "./src/client/constants/config.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var BASE_URL = exports.BASE_URL = 'http://www.adultswim.com';
var DATETIME_DISPLAY_FORMAT = exports.DATETIME_DISPLAY_FORMAT = 'MMMM Do YYYY';
var HOME_BASE_URL = exports.HOME_BASE_URL = '/';
var IMAGE_UPLOAD_URL = exports.IMAGE_UPLOAD_URL = '/comics/media/v1/upload';
var TWITTER_IMAGE_SHARE = exports.TWITTER_IMAGE_SHARE = 'https://twitter.com/intent/tweet?hashtags=adultswim,webcomics&text=' + encodeURI('Check out this thing I drew on http://adultswim.com.') + ' ';
var FACEBOOK_IMAGE_SHARE = exports.FACEBOOK_IMAGE_SHARE = 'https://www.facebook.com/dialog/feed?app_id=222143901136511&link=';

/***/ }),

/***/ "./src/client/containers/main/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _reactHelmet = __webpack_require__("./node_modules/react-helmet/lib/Helmet.js");

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _hero = __webpack_require__("./src/client/components/hero/index.js");

var _hero2 = _interopRequireDefault(_hero);

var _comics = __webpack_require__("./src/client/components/comics/index.js");

var _comics2 = _interopRequireDefault(_comics);

var _archive = __webpack_require__("./src/client/components/archive/index.js");

var _archive2 = _interopRequireDefault(_archive);

var _series = __webpack_require__("./src/client/components/series/index.js");

var _series2 = _interopRequireDefault(_series);

var _getData = __webpack_require__("./src/client/actions/getData.js");

var _templateSelector = __webpack_require__("./src/client/selectors/templateSelector.js");

var _comicsSelector = __webpack_require__("./src/client/selectors/comicsSelector.js");

var _styles = __webpack_require__("./src/client/containers/main/styles.less");

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MainContainer = function (_React$Component) {
    _inherits(MainContainer, _React$Component);

    function MainContainer(props) {
        _classCallCheck(this, MainContainer);

        var _this = _possibleConstructorReturn(this, (MainContainer.__proto__ || Object.getPrototypeOf(MainContainer)).call(this, props));

        _this.state = {};
        return _this;
    }

    _createClass(MainContainer, [{
        key: 'render',
        value: function render() {
            var _props$home = this.props.home,
                hero = _props$home.hero,
                layout = _props$home.layout;

            var artists = this.props.artists;
            var archive = this.props.series;
            var currentSeries = this.props.currentSeries;
            var vars = ['var strPageName = "Index"', 'var strSectionName = "Comics"', 'var strSubSectionName = ""'];

            return _react2.default.createElement(
                'div',
                { className: _styles2.default.root },
                _react2.default.createElement(
                    _reactHelmet2.default,
                    null,
                    _react2.default.createElement('html', { lang: 'en' }),
                    _react2.default.createElement('meta', { charSet: 'utf-8' }),
                    !!currentSeries && _react2.default.createElement(
                        'title',
                        null,
                        'Adult Swim Comics - ' + currentSeries.title
                    ),
                    !currentSeries && _react2.default.createElement(
                        'title',
                        null,
                        'Adult Swim Comics'
                    ),
                    _react2.default.createElement('meta', {
                        content: 'Weekly comics presented by Adult Swim for your viewing pleasure.',
                        name: 'description'
                    }),
                    _react2.default.createElement('meta', {
                        content: 'width=device-width,initial-scale=1',
                        name: 'viewport'
                    }),
                    _react2.default.createElement('meta', {
                        content: 'Adult Swim Comics, Scorpion Dagger, Buff Dudes, Buttfield, Jeroom, Street Wizard, Finish This, Crapland, A Portion of Dirt, Trust Zabo',
                        name: 'keywords'
                    }),
                    !currentSeries && _react2.default.createElement('link', {
                        href: 'https://www.adultswim.com/comics',
                        rel: 'canonical'
                    }),
                    !!currentSeries && _react2.default.createElement('link', {
                        href: 'https://www.adultswim.com/comics/' + currentSeries.id,
                        rel: 'canonical'
                    }),
                    _react2.default.createElement(
                        'script',
                        null,
                        vars.join('; ')
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: _styles2.default.contentWrapper },
                    _react2.default.createElement(_hero2.default, {
                        className: _styles2.default.hero,
                        data: hero
                    }),
                    _react2.default.createElement(_comics2.default, {
                        className: _styles2.default.comics,
                        data: layout
                    })
                ),
                _react2.default.createElement(_archive2.default, {
                    className: _styles2.default.archive,
                    data: archive
                }),
                !!currentSeries && _react2.default.createElement(_series2.default, {
                    artist: artists[currentSeries.artist],
                    className: _styles2.default.series,
                    data: currentSeries
                })
            );
        }
    }]);

    return MainContainer;
}(_react2.default.Component);

if (false) {
    var axios = require('axios');

    MainContainer.getInitialData = function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(match, _ref) {
            var PAGES_API_URL = _ref.PAGES_API_URL;

            var _ref3, _ref4, incoming;

            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return Promise.all([axios.request({ baseURL: PAGES_API_URL, url: '/v1/view/comics-www/all?flatten=true' })]);

                        case 2:
                            _ref3 = _context.sent;
                            _ref4 = _slicedToArray(_ref3, 1);
                            incoming = _ref4[0];
                            return _context.abrupt('return', (0, _getData.receiveData)(incoming.data.data.rows));

                        case 6:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined);
        }));

        return function (_x, _x2) {
            return _ref2.apply(this, arguments);
        };
    }();
}

function mapStateToProps(state, props) {
    return {
        home: (0, _templateSelector.templateSelector)(state),
        series: (0, _comicsSelector.comicsSelector)(state),
        artists: state.artists,
        currentSeries: (0, _comicsSelector.seriesSelector)(state, props)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(MainContainer);

/***/ }),

/***/ "./src/client/containers/main/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"stuck":"main__stuck_24gLY","root":"main__root_2IyvL","contentWrapper":"main__contentWrapper_36rjH","hero":"main__hero_2K8E-","comics":"main__comics_OWfZK","archive":"main__archive_3ONh6","series":"main__series_146RK"};

/***/ }),

/***/ "./src/client/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./node_modules/babel-polyfill/lib/index.js");

__webpack_require__("./node_modules/core-js/fn/object/assign.js");

__webpack_require__("./node_modules/core-js/fn/promise.js");

var _reactHotLoader = __webpack_require__("./node_modules/react-hot-loader/index.js");

var _reactRouterDom = __webpack_require__("./node_modules/react-router-dom/es/index.js");

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _reactRouterConfig = __webpack_require__("./node_modules/react-router-config/es/index.js");

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _store = __webpack_require__("./src/client/store.js");

var _routes = __webpack_require__("./src/client/routes.js");

var _routes2 = _interopRequireDefault(_routes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var store = (0, _store.configureStore)(window.__INITIAL_STATE__);
// Remove the initial state object from window
delete window.__INITIAL_STATE__;

function renderApp(routesConfig) {
    _reactDom2.default.hydrate(_react2.default.createElement(
        _reactHotLoader.AppContainer,
        null,
        _react2.default.createElement(
            _reactRedux.Provider,
            { store: store },
            _react2.default.createElement(
                _reactRouterDom.BrowserRouter,
                null,
                (0, _reactRouterConfig.renderRoutes)(routesConfig)
            )
        )
    ), document.getElementById('app'));
}

renderApp(_routes2.default);

if (false) {
    module.hot.accept('./routes.js', function () {
        var nextRoutes = require('./routes').default;
        renderApp(nextRoutes);
    });
}

/***/ }),

/***/ "./src/client/reducers/artistsReducer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _reduxActions = __webpack_require__("./node_modules/redux-actions/es/index.js");

exports.default = (0, _reduxActions.handleActions)({
	RECEIVE_DATA: function RECEIVE_DATA(state, action) {
		var artists = {};
		action.payload.forEach(function (item) {
			if (item.value.type == 'artist') {
				artists[item.value.id] = item.value;
			}
		});
		return Object.assign({}, state, artists);
	}
}, {});

/***/ }),

/***/ "./src/client/reducers/comicsReducer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _reduxActions = __webpack_require__("./node_modules/redux-actions/es/index.js");

exports.default = (0, _reduxActions.handleActions)({
	RECEIVE_DATA: function RECEIVE_DATA() {
		var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
		var action = arguments[1];

		var new_comics = {};
		action.payload.forEach(function (item) {
			if (item.value.type == 'series') {
				new_comics[item.value.id] = item.value;
			}
		});
		return Object.assign({}, state, new_comics);
	}
}, {});

/***/ }),

/***/ "./src/client/reducers/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _redux = __webpack_require__("./node_modules/redux/es/index.js");

var _artistsReducer = __webpack_require__("./src/client/reducers/artistsReducer.js");

var _artistsReducer2 = _interopRequireDefault(_artistsReducer);

var _comicsReducer = __webpack_require__("./src/client/reducers/comicsReducer.js");

var _comicsReducer2 = _interopRequireDefault(_comicsReducer);

var _templateReducer = __webpack_require__("./src/client/reducers/templateReducer.js");

var _templateReducer2 = _interopRequireDefault(_templateReducer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _redux.combineReducers)({
	artists: _artistsReducer2.default,
	comics: _comicsReducer2.default,
	template: _templateReducer2.default
});

/***/ }),

/***/ "./src/client/reducers/templateReducer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _reduxActions = __webpack_require__("./node_modules/redux-actions/es/index.js");

exports.default = (0, _reduxActions.handleActions)({
	RECEIVE_DATA: function RECEIVE_DATA() {
		var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
		var action = arguments[1];

		return Object.assign({}, state, action.payload.filter(function (item) {
			return item.value.type == 'homepage';
		}));
	}
}, []);

/***/ }),

/***/ "./src/client/routes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.COMIC_PATH = exports.COMICS_PATHNAME = undefined;

var _main = __webpack_require__("./src/client/containers/main/index.js");

var _main2 = _interopRequireDefault(_main);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var COMICS_PATHNAME = exports.COMICS_PATHNAME = '/comics';
var COMIC_PATH = exports.COMIC_PATH = '/comics/:slug?';

exports.default = [{
    component: _main2.default,
    path: COMIC_PATH
}];

/***/ }),

/***/ "./src/client/selectors/comicsSelector.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.seriesSelector = exports.comicsSelector = undefined;

var _reselect = __webpack_require__("./node_modules/reselect/lib/index.js");

var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");

var comicsSelector = exports.comicsSelector = (0, _reselect.createSelector)(function (state) {
	return state.comics;
}, function (state) {
	return state.artists;
}, function (comics, artists) {
	var comicsNew = {};
	for (var series in comics) {
		series = comics[series];
		var s = {};
		s.title = series.title;
		var artist = (0, _lodash.get)(artists, series.artist);
		if (artist) {
			s.artist = (0, _lodash.get)(artist, 'name');
			s.artistSite = (0, _lodash.get)(artist, 'artistSite');
			s.maxWidth = series.maxWidth;
			s.archiveThumbnail = series.archiveThumbnail;
			s.reverseOrder = series.reverse;
			s.isDrawable = series.isDrawable;
			s.comics = [];
			for (var comic in series.comics) {
				var c;
				if (series.comics[comic].mobile.url) {
					c = {
						'desktop': series.comics[comic].desktop.url,
						'mobile': series.comics[comic].mobile.url
					};
				} else {
					c = series.comics[comic].desktop.url;
				}
				s.comics.push(c);
			}
			comicsNew[series.id] = s;
		}
	}
	return comicsNew;
});

var seriesSelector = exports.seriesSelector = (0, _reselect.createSelector)(function (state) {
	return state.comics;
}, function (state, props) {
	return props.match.params.slug;
}, function (comics, slug) {
	return comics[slug];
});

/***/ }),

/***/ "./src/client/selectors/templateSelector.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.templateSelector = undefined;

var _reselect = __webpack_require__("./node_modules/reselect/lib/index.js");

var templateSelector = exports.templateSelector = (0, _reselect.createSelector)(function (state) {
	return state.template;
}, function (templates) {
	var recent_modified = 0;
	var recent_template;
	for (var i in templates) {
		if (templates[i].value.modified > recent_modified) {
			recent_template = templates[i];
			recent_modified = templates[i].value.modified;
		}
	}
	return recent_template.value;
});

/***/ }),

/***/ "./src/client/store.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.configureStore = undefined;

var _redux = __webpack_require__("./node_modules/redux/es/index.js");

var _reduxThunk = __webpack_require__("./node_modules/redux-thunk/lib/index.js");

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _reduxDevtoolsExtension = __webpack_require__("./node_modules/redux-devtools-extension/index.js");

var _reducers = __webpack_require__("./src/client/reducers/index.js");

var _reducers2 = _interopRequireDefault(_reducers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var configureStore = exports.configureStore = function configureStore(initialState) {
    var store = (0, _redux.createStore)(_reducers2.default, initialState, (0, _reduxDevtoolsExtension.composeWithDevTools)((0, _redux.applyMiddleware)(_reduxThunk2.default)));

    if (false) {
        module.hot.accept('./reducers', function () {
            var nextReducer = require('./reducers').default;
            store.replaceReducer(nextReducer);
        });
    }

    return store;
};

/***/ })

},["./src/client/index.js"]);


// WEBPACK FOOTER //
// comics.9ef3cae85372f3a01642.js